module.exports = __webpack_public_path__ + "img/p04.49603a94.jpg";